import { AfterViewInit, Component, Inject, OnDestroy, OnInit, inject } from '@angular/core';
import moment from 'moment';

import { InvestimentsBase } from '../investiments.base';
import { SharesService } from './shares.service';
import { ShareCreateComponent } from './create/create.component';
import { ShareModifyComponent } from './modify/modify.component';
import { CompaniesService } from '../companies/companies.service';

@Component({
  selector: 'app-shares',
  standalone: false,
  templateUrl: './shares.component.html',
  styleUrl: './shares.component.scss'
})
export class SharesComponent extends InvestimentsBase<ShareCreateComponent, ShareModifyComponent> implements AfterViewInit {

  override service = inject(SharesService)
  companiesService = inject(CompaniesService)

  override list : any = {
    columns: [
      'company', 'code', 'alias', 'type', 'site', 'action'
    ],
    data: []  
  }
  
  constructor() {
    super(ShareCreateComponent, ShareModifyComponent)

    this.companiesService.selectAll()
  }

  async ngAfterViewInit(): Promise<void> {
    console.error('SharesComponent -> ngAfterViewInit')

    console.log("listShares: ", this.list.data)
  }

  // override async evaluate(r: any):Promise<boolean> {
  //   console.error('SharesComponent -> evaluate', r)

  //   return await true
  // }
  
}
